import styled from '@emotion/styled';

export default styled.div`
  display: flex;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  font-family: "Inter", sans-serif;
  flex-direction: column;
  font-weight: 400;
  line-height: 1.5;
`;
